(function () {
	const initProductAccordion = (container = document) => {
		$(container)
			.find(".product-about__accordion-title")
			.off("click.productAccordion")
			.on("click.productAccordion", function () {
				const $control = $(this);
				const $panel = $control
					.closest(".product-about__accordion-item")
					.children(".product-about__accordion-content");

				if (!$control.hasClass("active")) {
					$(".product-about__accordion-title.active")
						.removeClass("active")
						.attr("aria-expanded", "false");
					$control.addClass("active").attr("aria-expanded", "true");
					$(".product-about__accordion-content").stop().slideUp(200);
					$panel.stop().slideDown(200);
				} else {
					$control.removeClass("active").attr("aria-expanded", "false");
					$panel.stop().slideUp(200);
				}
			});
	};

	document.addEventListener("shopify:section:load", function (event) {
		initProductAccordion(event.target);
	});

	initProductAccordion();
})();
